<div class="simpleMenu" #container [ngClass]="{ 'is-expanded': isExpanded, 'has-expansion': isExpandable }">
  <button *ngIf="isExpandable" type="button" class="btn btn-light btn-expansion text-end"
          (click)="isExpanded = !isExpanded"
          [title]="(isExpanded) ? 'Shrink Menu' : 'Expand Menu'">
    <i class="fas" [ngClass]="(isExpanded) ? 'fa-chevron-left' : 'fa-chevron-right'"></i>
  </button>
  <ng-content></ng-content>
</div>
